import React from 'react';
import PropTypes from 'prop-types';
import { grey } from '@mui/material/colors';
import makeStyles from '@mui/styles/makeStyles';

import { theme } from 'theme';

const useStyles = makeStyles({
  container: {
    filter: 'drop-shadow(0px 2px 2px #ccc)',
    display: 'flex',
    justifyContent: 'center',
    position: 'relative',
    paddingTop: theme.spacing(2),
    minWidth: 400,
  },
  pyramid: {
    clipPath: 'polygon(50% 0, 100% 100%, 0 100%, 0 100%)',
    width: 150,
    display: 'flex',
    boxShadow: '5px 5px 5px #000',
    flexDirection: 'column-reverse',
    '& > div': {
      height: 35,
    },
  },
  data: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    paddingLeft: 130,
    paddingRight: 130,
    display: 'flex',
    flexDirection: 'column-reverse',
    '& > div': {
      height: 35,
      borderBottom: `1px dashed ${grey[400]}`,
      display: 'flex',
      justifyContent: 'space-between',
      '&:before, &:after': {
        width: 130,
        display: 'flex',
        alignItems: 'center',
        height: '100%',
        fontSize: 13,
        fontWeight: 500,
      },
      '&:before': {
        paddingRight: theme.spacing(1),
        content: 'attr(data-label)',
        transform: 'translate(-100%, 0)',
      },
      '&:after': {
        paddingLeft: theme.spacing(1),
        content: 'attr(data-value)',
        transform: 'translate(100%, 0)',
        justifyContent: 'flex-end',
      },
    },
  },
  highlight: {
    'div&': {
      borderColor: theme.palette.primary.main,
      color: theme.palette.primary.main,
    },
  },
});

const getColor = (index, isHighlighted) => {
  if (isHighlighted) {
    return theme.palette.primary.main;
  }

  switch (index) {
    case 0:
      return '#fff';
    default:
      return grey[index * 100];
  }
};

const PyramidChart = ({ data, highlight, ...props }) => {
  const classes = useStyles();

  return (
    <div className={classes.container} {...props}>
      <div className={classes.data}>
        {data.map((item, index) => {
          const divClassName = highlight === index ? classes.highlight : undefined;

          return (
            <div
              key={item}
              data-label={`Level ${index + 1}`}
              data-value={item}
              className={divClassName}
            />
          );
        })}
      </div>
      <div className={classes.pyramid}>
        {data.map((item, index) => {
          const isHighlighted = highlight === index;

          return <div key={item} style={{ backgroundColor: getColor(index, isHighlighted) }} />;
        })}
      </div>
    </div>
  );
};

PyramidChart.defaultProps = {
  highlight: undefined,
};

PyramidChart.propTypes = {
  data: PropTypes.array.isRequired,
  highlight: PropTypes.number,
};

export default PyramidChart;
